<template>
<div class="input-container">
    <b-input-group>
        <template #prepend>
            <font-awesome-icon :icon="['fas', 'search']" />
        </template>
        <b-form-input v-model="searchText" placeholder="What would you like to explore?"></b-form-input>
        <template #append>
            <button @click="handleClick" class="btn-yellow" type="submit">Search</button>
        </template>
    </b-input-group>
</div>
</template>

<script>
export default {
    name: "input-box",
    data: function () {
        return {
            searchText: ''
        }
    },
    methods: {
        handleClick() {
            this.$emit('handleSearch', this.searchText)
        }
    }
}
</script>

<style lang="scss" scoped>
.input-group {
    width: 100% !important;
    margin: 0 auto !important;

}

.input-group-prepend {
    padding-top: 8px !important;
    margin-right: 10px !important;
}

.input-container {
    margin: 0 auto;
    border: 1px solid #fff;
    padding: 19px;
    width: 40%;
    border-radius: 5px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 7px;
        width: 80%;

    }
    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) { 
       width: 60%;
    }
     @media screen and (min-device-width: 712px) and (max-device-width: 1138px) 
    and (-webkit-min-device-pixel-ratio: 1) { 
       width: 60%;
       padding: 10px;
    }
}

.btn-yellow {
    width: 70px;
    height: 34px;
    left: calc(50% - 74px/2 + 166px);
    top: calc(50% - 35px/2);
    background: #F7B131;
    border-radius: 0 4px 4px 0;
    border: none;
    z-index: 99;
    color: #fff;
     @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        font-size: 0.8rem; /* Use rem for font size */

    }
   
}

.form-control {
    background-color: transparent !important;
    border: none !important;
    color: #fff !important;
    font-size: 13px !important;
}

.form-control:focus {
    box-shadow: none !important;
    color: #fff !important;
}
</style>
